import { useContext } from "react";

import classNames from "classnames";
import styles from "./styles/BottomUserDetails.module.scss";
import { observer } from "mobx-react";
import {StoreContext} from "../../../../stores/StoreLoader";

import ImageComponent from "../../../utilities/ImageComponent";
import FlatIcon from "../../../utilities/FlatIcon";

const userImageClassName = classNames({
    [styles.userImage]: true,
});
const userImagePlaceholderClassName = classNames({
    [styles.userImage]: true,
    [styles.userImagePlaceholder]: true,
    [styles.roundIcon]: true,
});
const bottomUserDetailsClassName = classNames({
    [styles.bottomUserDetails]: true,
});

const BottomUserDetails = observer(props => {
    const {userStore} = useContext(StoreContext);

    let UserImage;
    if (userStore.avatar && userStore.avatar.length > 0) {
        UserImage = <ImageComponent src={userStore.avatar} alt="User Profile Picture" className={userImageClassName}/>;
    } else {
        UserImage =
            <FlatIcon className={userImagePlaceholderClassName} name="flaticon-man"/>;
    }

    let UserName = `${userStore.firstName || ""} ${userStore.lastName || ""}`;

    return (
        <section className={bottomUserDetailsClassName}>
            {UserImage}
            <h2>{UserName}</h2>
        </section>
    );
});

export default BottomUserDetails
